<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file CarParkTickets.vue is part of event_pass_client.dev.            -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - CarParkTickets.vue can not be copied and/or distributed                   -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.--><!--//User: keni--><!--//Date: 28/02/2018--><!--//Time: 11:52-->

<template>
    <div class="">
        <!--show the entity details-->

        <!--eof show the entity details-->

        <!--tickets list and google map-->
        <div class="row no-gutters">
            <ticket-entity-preview
                    :width="entity_preview.width"
                    :position_offset="entity_preview.width + 30"
                    :entity="entity_preview.entity"
                    :displayChanged="entity_preview.displayChanged"
                    @close_preview="previewClosed()"
            />

            <div class="bg-level-3 google-maps-ticket-selection-wrapper"
                 ref="ticket_wrapper"
                 :class="ticket_classes.responsive.tickets"
            >

                <template v-if="!tickets.length">
                    <hr>
                    <BaseLoadingAnimation text="getting tickets..."/>
                    <hr>
                </template>

                <div v-if="tickets.length > 0">
                    <ticket-list
                            :map_lat="map_lat"
                            :map_lng="map_lng"
                            :user="user"
                            :payment_intent_request="payment_intent_request"
                            :ticket_wrapper_id="ticket_wrapper_id"
                            :show_remaining="show_remaining"
                            :tickets="tickets"
                            :maps_assets="maps_assets"
                            :entity_id_prefix="entity_id_prefix"
                            :images="images"
                            :images_url="images_url"
                            :add_ticket_url="add_ticket_url"
                            :entity="entity"
                            :ticket_classes="ticket_classes"
                            :pay_with_card_url="pay_with_card_url"
                            :my_account_url="my_account_url"
                            :start_date="start_date"
                            :entity_highlight_target="entity_highlight_target"
                            :stripe_use="stripe_use"
                            @event_handler="eventHandler"
                            @entity_selected="entitySelected"
                    />

                </div>
                <div class="mt-5" v-else>
                    <h4 class="text-center mt-5">No tickets on sale</h4>
                </div>
                <!--</transition>-->
            </div>
            <transition name="fade"
                        :duration="{ enter: 500, leave: 800 }">
                <!--the full page google map-->
                <div data-element="vue2-google-maps"
                     v-if="map_now_loaded"
                     class="vue2-google-maps-wrapper"
                     :class="ticket_classes.responsive.maps"
                >
                    <!--{{log(google_maps.markers)}}-->
                    <!--<h1>Google maps TEST</h1>-->
                    <google-map :center="google_maps.center"
                                :id="google_maps.id"
                                ref="gmap"
                                :zoom="zoom.set"
                                :class="google_maps.elmClass"
                                @bounds_changed="info.bounds = $event"
                                @zoom_changed="info.zoom = $event"
                                :options="google_maps.options"

                    >
                        <!--will render the window on click of the marker-->
                        <gmap-info-window :options="google_maps.infoOptions"
                                          :position="google_maps.infoWindowPos"
                                          :opened="google_maps.infoWinOpen"
                                          @closeclick="closeInfoWindow"

                        >
                            <div class="google-maps-entity">

                                <h6 class="google-maps-entity--title">
                                    {{google_maps.infoContent.title}}
                                </h6>

                                <small v-if="google_maps.infoContent.description.short !== ''"
                                       class="d-block text-dark google-maps-entity--title-short"
                                > {{google_maps.infoContent.description.short}}
                                </small>

                                <div v-if="google_maps.infoContent.sign"
                                     class="d-flex justify-content-between align-items-center "
                                >
                                    <div class="entity--sign entity--sign-small">
                                        <div class="d-block m-0 px-half lh-10 fs-5 text-dark z-depth-1">
                                            {{google_maps.infoContent.sign}}
                                        </div>
                                    </div>
                                    <div class="ml-2">Look for this sign when getting closer to your destination</div>
                                </div>
                            </div>
                        </gmap-info-window>

                        <!--basic marker-->
                        <template v-for="(marker,index) in google_maps.markers">

                                <gmap-marker :key="index"
                                             :position="marker.position"
                                             :clickable="true"
                                             @click="mapIconClicked(marker)"
                                             :icon="mapIcon(marker)"
                                />

                        </template>
                        <!--venue marker-->
                        <gmap-marker
                                :position="createGoogleMarker(tickets,'venue').position"
                                :clickable="false"
                                :icon="mapIcon('venue')"
                        />
                    </google-map>
                </div>
                <div v-else
                     :id="page_event_id + '--clone-me'"
                     class="d-none d-md-block px-4 col z-index-1">
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <ImageResponsive
                                    :image="event_details.image_set||null"
                                    :alt="event_details.title"
                                    default_size="sm"
                                    class="img-fluid"
                            >
                            </ImageResponsive>
                        </div>
                        <div class="col-12 col-lg-8">
                            <h1>{{event_details.title}} <br></h1>
                            <div class="text-muted fs-5">
                                {{event_details.date}}
                            </div>

                            <div v-if="event_details.short != null"
                                 class="mb-1"
                                 v-html="event_details.short"
                            >
                            </div>
                            <div v-if="event_details.long != null"
                                 class="mb-1"
                                 v-html="event_details.long">
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {GOOGLEMAPS_API_KEY} from '../../config/config';
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {format as formatMoney} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';
    import {ticket_types} from '../../../../../app/Shared/Resources/Assets/js/helpers/ticketIcons';
    import {_} from 'underscore';

    import * as VueGoogleMaps from 'vue2-google-maps';
    import GmapCustomMarker from '../maps/gmap-custom-marker';

    import windowDimensions from '../../../../../app/Shared/Resources/Assets/js/helpers/window.tools';
    import {uniqueId} from '../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';
    import {truncate} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.string';
    import {stringToProperty} from '../../../../../app/Shared/Resources/Assets/js/helpers/object.formats';
    import TicketsAnimation from './TicketsAnimation';

    Vue.component('bold-words', require('../../../../../app/Shared/Resources/Assets/js/components/BoldWords'));
    let VueScrollTo = require('vue-scrollto');
    Vue.use(VueScrollTo);
    Vue.component('ticket-entity-preview', require('./TicketEntityPreview'));

    Vue.component('ticket-list', require('./TicketList.vue'));
    Vue.use(VueGoogleMaps, {
        load: {
            key: GOOGLEMAPS_API_KEY,
            // v: '3.26',
            // v: 'OPTIONAL VERSION NUMBER',
            // libraries: 'places', //// If you need to use place input
        }
    });
    Vue.component('google-map', VueGoogleMaps.Map);
    export default {
        name: "car-park-tickets",
        mixins: [TicketsAnimation],
        components: {
            'gmap-custom-marker': GmapCustomMarker
        },
        props: {
            map_lat: {
                type: Number,
                default: null
            },
            map_lng: {
                type: Number,
                default: null
            },
            page_event_id: {
                type: String,
                default: 'event-page-id'
            },
            user: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            payment_intent_request: {
                type: String,
                default: null
            },
            tickets_loaded: {
                type: Boolean,
                default: false
            },
            event_details: Object,
            basic_marker: {
                type: Boolean,
                default: false
            },
            show_remaining: Boolean,
            car_park_tickets: Array | Function,
            images_url: Object,
            add_ticket_url: Object,
            pay_with_card_url: Object,
            my_account_url: Object,
            start_date: String | Function,
            maps_assets: Object,
            stripe_use: {
                type: Object,
                default: null
            },
        },
        created() {
            let self = this;

        },
        destroyed() {
            // window.removeEventListener('scroll', this.handleScroll);
        },
        mounted() {
            let self = this;
            this.$nextTick(() => {
                // console.log('this.$refs.gmap',this.$refs.gmap);
                // this.$refs.gmap.$mapCreated.then(() => {
                // 	console.log(bounds);
                // 	// this.$refs.gmap.$mapObject.fitBounds(bounds);
                // });
            });

        },
        data() {
            return {
                animateEventDescription: false,
                entity_preview: {
                    width: 150,
                    entity: Object,
                    displayChanged: false,
                    show: false
                },
                info: {
                    zoom: {},
                    bounds: {}
                },
                debug_zoom_level: '',
                debug_bounds: '',
                zoom: {
                    set: 16,
                    out: 16,
                    in: 19
                },
                entity_id_prefix: 'entity--tickets-id',
                show_map: true,
                ticket_wrapper_id: this.uniqueId('tickets-wrapper'),
                defaultMapCenter: {
                    lat: this.map_lat,
                    lng: this.map_lng
                },
                mapSettings: {
                    defaultIconSettings: {},
                    defaultMapOptions: {
                        /* below, useful default options */
                        clickableIcons: false,
                        streetViewControl: false,
                        panControlOptions: false,
                        gestureHandling: 'greedy'
                    }
                },
                map_loaded: false,
                tickets: Array,
                show_entity: false,
                entity: Object,
                entities: {},
                images: {},
                ticket_classes: {
                    tickets: {
                        wrapper: '',
                        ticket: 'bg-level-4'
                    },
                    responsive: {
                        tickets: 'col-12 col-md-5',
                        maps: 'd-none d-md-flex col-md-7',
                    }
                },
                entity_highlight_target: Number,
                google_maps: {
                    options: {
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                        disableDefaultUi: false,
                        clickableIcons: false
                    },
                    marker_icons: {
                        assets_path: 'est-event-pass-assets/images/map-markers/',
                        car_park: 'ricoh--map-marker-car.png',
                        bus: {},

                    },
                    id: uniqueId('google_maps'),
                    elmClass: '',
                    center: {
                        lat: this.map_lat,
                        lng: this.map_lng
                    },
                    infoContent: {
                        title: '',
                        description: {
                            long: '',
                            short: ''
                        }
                    },
                    infoWindowPos: {
                        lat: 0,
                        lng: 0
                    },
                    marker_params: {},
                    infoWinOpen: false,
                    currentMidx: null,
                    //optional: offset infowindow so it visually sits nicely on top of our marker
                    infoOptions: {
                        pixelOffset: {
                            width: 0,
                            height: -35
                        },
                        maxWidth: 300
                    },
                    markers: []
                }
            }
        },
        methods: {
            log() {
                console.log.apply(console, arguments);
            },
            previewClosed() {
                this.entity_preview.displayChanged = false;
                // console.log('closed',this.entity_preview.displayChanged);
                this.$nextTick(() => {
                    this.setMapBounds();
                })
            },
            setMapBounds() {
                if (typeof this.$refs.gmap !== 'undefined') {
                    this.$refs.gmap.$mapCreated.then(() => {
                        const size = _.size(this.google_maps.markers);
                        // console.log('size', size);
                        if (size > 0) {
                            const bounds = new google.maps.LatLngBounds();
                            // console.log('bounds', bounds);
                            _.forEach(this.google_maps.markers, function (marker) {
                                // console.log('marker',marker);
                                bounds.extend(marker.position);
                            });

                            // add the venue bounds
                            bounds.extend({
                                lat: this.map_lat,
                                lng: this.map_lng

                            });

                            // console.log('bounds',bounds);
                            this.$refs.gmap.fitBounds(bounds);
                        }
                    });
                    Vue.$gmapDefaultResizeBus.$emit("resize");
                }

            },
            entitySelected(entity) {
                // console.log('entitySelected', entity);
                let self = this;
                self.entity_preview.entity = entity;
                self.entity_preview.displayChanged = true;

                self.entity_preview.width = this.$refs.ticket_wrapper.clientWidth;

                // console.log('google_maps.markers', self.google_maps.markers);

                let targetMarker = _.findWhere(self.google_maps.markers, {
                    entity_id: entity.id
                });

                // console.log('targetMarker', targetMarker);

                this.scrollToEntity(entity.id);
                if (typeof targetMarker !== 'undefined' && targetMarker !== null) {
                    this.setCenter(targetMarker.position)
                }
                //

            },

            openInfoWindow(marker) {
                if (!(typeof marker !== 'undefined' && marker !== null)) {
                    return false;
                }
                // console.log('marker',marker);
                this.google_maps.infoWindowPos = marker.position;
                this.google_maps.infoContent = marker.infoContent;
                this.google_maps.infoWinOpen = true;
            },
            closeInfoWindow() {
                // console.log('zoom out');
                let self = this;

                // console.log('closed');
                // close the window
                self.google_maps.infoWinOpen = false;
                // reset the zoom to default

                // https://stackoverflow.com/questions/19304574/center-set-zoom-of-map-to-cover-all-visible-markers
                // git issue question ref: Bounds and Zoom are not reactive
                // fit bounds https://github.com/xkjyeah/vue-google-maps/issues/25
                self.setCenter();

                self.setMapBounds();
                self.zoom.set = self.zoom.out;

            },

            scrollToEntity(entity_id) {
                let targetElement = `${this.entity_id_prefix}${entity_id}`;

                VueScrollTo.scrollTo(`#${targetElement}`, 500, {
                    container: `#${this.ticket_wrapper_id}`,
                    easing: 'ease-in',
                    offset: -1,
                    force: true,
                    cancelable: true,
                    // onStart: function (element) {
                    //     // scrolling started
                    // },
                    onDone: function (element) {
                        // scrolling is done
                        // console.log('element',element);
                        element.querySelector('header').classList.add('highlight');
                        setTimeout(function () {
                            element.querySelector('header').classList.remove('highlight');
                        }, 2000);
                    },
                    // onCancel: function () {
                    // 	// scrolling has been interrupted
                    // },
                    x: false,
                    y: true
                });
            },
            mapIconClicked(marker) {
                // console.log('mapIconClicked', marker);
                this.entity_highlight_target = marker.entity_id;
                // console.log('this.entity_highlight_target', this.entity_highlight_target);
                this.google_maps.center = marker.position;

                // zoom back out to default
                if (this.zoom.set > this.zoom.out) {
                    this.closeInfoWindow();
                } else {
                    // console.log('zoom in');
                    this.scrollToEntity(marker.entity_id);
                    this.zoom.set = this.zoom.in;
                    this.openInfoWindow(marker);
                }

            },
            createGoogleMarker(tickets, marker_type) {
                if (marker_type === 'venue') {

                    return {
                        position: {
                            lat: this.map_lat,
                            lng: this.map_lng
                        },
                        icon: 'car'
                    };
                }
            },
            mapIcon(marker_name) {
                if (marker_name == 'venue') {
                    return process.env.MIX_VENUE_MARKER;
                } else {
                    return process.env.MIX_MAPS_MARKER_CAR;
                }
                // console.log('mapIcon', 'this.images_url', this.images_url);
                //return process.env.MIX_MAPS_MARKER_CAR;
                // return {
                // 	url: this.images_url.data + this.google_maps.marker_icons.assets_path + this.google_maps.marker_icons.car_park
                // }
            },
            eventHandler(obj) {
                switch (obj.action) {
                    case 'show_entity':
                        this.show_entity = obj.show_entity;
                        this.entity = obj.entity;
                        break;
                }
            },
            applyImage(tickets) {
                let image = this.createMainImage(tickets);
                console.log('image', image);
                return this.images[image].src;
            },
            preloadImage(tickets) {
                let url = this.createMainImage(_.first(tickets).entity);
                if (url === null) {
                    return null;
                }
                if (url in this.images) {
                    return this.images[url];
                } else {
                    console.warn('no image');
                    let my_image = new Image();

                    my_image.onload = function () {
                        console.log('image loaded');
                    };
                    my_image.src = url;
                    this.$set(this.images, url, my_image);
                    // this.images.put(url,my_image);
                    return my_image;
                }

            },
            ticketTypeIconClass(ticket) {
                return ticket_types(ticket.ticket_type, false);
            },
            createMainImage(entity) {
                let url = this.readImageFromData(entity);
                if (url === null) {
                    console.error('images is null', entity);
                    return null;
                }
                url = this.images_url.data + '/' + url.url;
                return url;
            },
            /**
             * User clicks to show the entity
             * @param entity
             */
            viewEntity(entity) {
                this.show_entity = false;
                console.log('closing', entity);

                this.$nextTick(function () {
                    // open the entity
                    console.log('opening');
                    // close the entity preview if it is open
                    this.entity = entity;
                    this.show_entity = true;

                })
            },
            formatMoney(price) {
                return formatMoney(price, {
                    code: $('body').data('currency')
                });
            },
            firstRecord(data) {
                return _.first(data);
            },
            groupByEntity() {
                // console.log('this.tickets',this.tickets);
                return _.groupBy(this.tickets, function (item) {
                    return item.entity_id;
                });
            },
            log(ref, obj) {
                if (typeof (console) !== 'undefined') {
                    console.log.apply(console, arguments);
                }
            },
            createEntitiesFromGrouped(grouped) {
                let compiledEntities = {};

                for (let entityKey in grouped) {
                    // console.log('entityKey',_.first(grouped[entityKey]));
                    if (!this.entities.hasOwnProperty(entityKey)) {
                        let entityData = _.first(grouped[entityKey]).entity;

                        let obj = {};
                        obj[entityData.id] = entityData;
                        _.extend(compiledEntities, obj);
                    }
                }
                this.entities = compiledEntities;
                // console.log('this.entities',this.entities);
                this.createGoogleMapsInfoWindowData();
                // console.log('this.google_maps', this.google_maps);
            },
            createGoogleMapsInfoWindowData() {
                let compiledInfoData = [];
                let self = this;


                for (let entity_id in this.entities) {
                    // console.log('createGoogleMapsInfoWindowData', 'entity', entity_id);
                    let entityData = this.entities[entity_id].entity_data;

                    // console.log('entityData', entityData);
                    let test = stringToProperty('entity_type.entity_type_data.input_fields.groups.location', entityData);

                    // console.log('createGoogleMapsInfoWindowData', 'test', test);
                    if (typeof test !== 'undefined' && test !== null) {
                        let gmapsData = entityData.entity_type.entity_type_data.input_fields.groups.location.items,
                            /**
                             * @property geoCodeValue.geometry
                             * @namespace geoCodeValue
                             */
                            geoCodeValue = JSON.parse(gmapsData.geocode.value);

                        if (typeof geoCodeValue !== 'undefined' && geoCodeValue !== null) {
                            let lat = geoCodeValue.geometry.location.lat,
                                long = geoCodeValue.geometry.location.lng,
                                title = lang('title', entityData.lang),
                                sign = (('sign' in entityData) ? entityData.sign : null),

                                description = {
                                    short: lang('description.short', entityData.lang),
                                    long: lang('description.long', entityData.lang)
                                };
                            compiledInfoData.push({
                                entity_id: parseInt(entity_id),
                                position: {
                                    lat: parseFloat(lat),
                                    lng: parseFloat(long)
                                },
                                infoContent: {
                                    sign: sign,
                                    title: title,
                                    description: description,
                                    maxWidth: 250
                                },
                                icon: 'car'
                            });
                        } else {

                        }
                    }

                    // console.log('compiledInfoData',compiledInfoData);
                }
                // console.log('compiledInfoData', compiledInfoData);
                this.google_maps.markers = compiledInfoData;

                setTimeout(function () {
                    self.map_loaded = true;
                    setTimeout(function () {
                        self.setMapBounds();
                        ;
                    }, 300);
                }, 2000)
            },
            setCenter(set) {
                if (typeof set !== 'undefined' && set !== null) {
                    this.google_maps.center = {
                        lat: set.lat,
                        lng: set.lng
                    };
                } else {
                    this.google_maps.center = {
                        lat: this.map_lat,
                        lng: this.map_lng
                    };
                }

                return this.google_maps.center;
            },
            uniqueId(item) {
                return _.uniqueId(item);
            },
            isEmpty(obj) {
                return _.isEmpty(obj);
            },
            empty(object) {
                return _.isEmpty(object);
            },
            debug() {
                if (typeof (console) !== 'undefined') {
                    console.log.apply(console, arguments);
                }
            },
        },
        computed: {
            map_now_loaded() {
                this.animateEventDescription = this.show_map && this.map_loaded && this.google_maps.markers.length;
                // if(this.animateEventDescription){
                //     animateToTargetEvent(this.page_event_id)
                // }
                // return false;
                return this.animateEventDescription;
            }
        },
        watch: {
            animateEventDescription() {
                let self = this;

                if (self.animateEventDescription) {
                    self.animateToTargetEvent(self.page_event_id,self.page_event_id + '--clone-me')
                }
            },
            /**
             * On call will compile the tickets result and compile entity groups for google maps
             * @param car_park_tickets
             */
            car_park_tickets(car_park_tickets) {
                // console.log('car_park_tickets', 'car_park_tickets', car_park_tickets);
                // console.log('this.start_date', this.start_date, typeof this.start_date);

                this.tickets = car_park_tickets;

                let grouped = _.groupBy(this.tickets, function (item) {
                    return item.entity_id;
                });
// console.log('car_park_tickets', 'grouped',grouped);
                this.createEntitiesFromGrouped(grouped);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/tickets/CarParkTickets.vue